
import {Component, Prop, Vue} from "vue-property-decorator";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
import AppSwitch from "@/components/AppSwitch.vue";
import {IApp} from "@/interfaces/app.interface";
import {IHome} from "@/modules/Home/interfaces/home.interface";
import {IProfile} from "@/modules/Profile/interfaces/profile.interface";
import moment from "moment/moment";

interface IControlBlock {
  type: 'link' | 'customComponent' | 'switcher';
  icon: string;
  label: string;
  info?: string;
}

interface IControlLink extends IControlBlock {
  link?: {
    href?: string;
    routeName?: IApp.ROUTE_NAME;
    query?: string;
    params?: any;
    hash?: string;
  };
  customAction?: Function;
}

interface IControlSwitcher extends IControlBlock {
  valueName: string;
  input: Function;
}

interface IControlComponent extends IControlBlock {
  specialTemplate?: boolean;
  componentName: string;
  props?: any;
}

type ControlType = IControlLink | IControlComponent | IControlSwitcher;

@Component({
  components: {AppSwitch, ThemeSwitcher}
})
export default class HomeAdditionalControls extends Vue {
  @Prop() homeData: IHome.IData;

  pages = IApp.ROUTE_NAME;
  switchers = {
    extModeFlag: false,
  };
  profileSettingsLink = {
    link: {
      routeName: IApp.ROUTE_NAME.PAGE_PROFILE,
      hash: `#${IProfile.PageTab.Theme}`,
    }
  };
  lastUpdate = '';

  get controlList(): ControlType[] {
    let result: ControlType[] = [
      {
        type: 'link',
        label: 'История движений',
        icon: 'truck',
        link: { routeName: IApp.ROUTE_NAME.PAGE_REPORT_MOVEMENTS}
      },
      {
        type: 'switcher',
        label: 'Расширенный режим',
        info: 'В интерфейсе доп. поля, фильтры, пункты меню',
        icon: 'crown',
        valueName: 'extModeFlag',
        input: (value) => {
          this.switchers.extModeFlag = value;
          this.$store.dispatch('profile/saveExtModeFlag', { value });
        },
      },
      {
        type: 'customComponent',
        label: 'Темная тема',
        icon: 'moon',
        componentName: 'ThemeSwitcher',
        specialTemplate: true,
      },
      {
        type: 'link',
        label: 'Привязать платежную карту',
        icon: 'credit-card',
        link: {
          routeName: IApp.ROUTE_NAME.PAGE_PROFILE,
          hash: `#${IProfile.PageTab.Payment}`,
        },
      },
      {
        type: 'link',
        label: 'Обновить версию',
        info: `Последнее обновление: ${ this.lastUpdate }`,
        icon: 'rotate-right',
        link: {
          routeName: IApp.ROUTE_NAME.REDIRECT_WITHOUT_CACHE,
        },
      },
    ];

    if (Boolean(this.homeData.requestAccessFlag)) {
      result.unshift({
        type: 'link',
        label: 'Запросить доступ к частной парковке',
        icon: 'house-lock',
        customAction: this.openGetAccessPopup
      });
    }

    return result;
  }

  created() {
    this.switchers.extModeFlag = this.homeData.extModeFlag;

    let storageDate = localStorage.getItem(IApp.LocalStorageKeys.LastAppUpdateDate);
    if (storageDate) {
      this.lastUpdate = moment(storageDate).format(IApp.DateFormats.PrintedDateTime);
    }
  }

  async openPage(controlItem: IControlLink) {
    if (controlItem.link.href) return;
    await this.$store.dispatch('openPage', {...controlItem.link});
  }

  async openGetAccessPopup() {
    await this.$store.dispatch('dialog/openDialog', { blockName: 'home', dialogName: 'getAccess', });
  }

}
